/*
 * @Description: 
 * @LastEditors: wjx
 * @Date: 2020-11-14 17:08:35
 */
import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import Config from '@/config/index.js';
import { userGuide } from '@/service/user.js';
import { getStorage } from '@/utils/storage';

export default () => {
  router.beforeEach((to, from, next) => {
    document.title = to.meta.pageName;
    store.commit('SET_LOADING', true);
    userGuide(to, from, next);
  });
  router.afterEach((to, from) => {
    store.commit('SET_LOADING', false);
    let channelNo = to.params.channelNo;
    let storageObj = getStorage('channel' + channelNo);
    let shence_id = '';
    // 拼接用户ID并登录神策,如果当前userId没有则先退等
    if (channelNo && storageObj) {
      shence_id = 'jhsaas_' + storageObj.id;
      Vue.prototype.$sa.login(storageObj.id);
    }else{
      Vue.prototype.$sa.logout();
    }
    // 传入神测公共数据
    let obj = {
      shence_id,
      channel_no: channelNo || '', // 当前专区编号
      fromcode: 'webview', // 来源
      platform: 'saas_polymerization_c',
      frompage_name: from.meta.scName || from.meta.pageName || '',
      frompage_url: from.fullPath || '',
      currentpage_name: to.meta.scName || to.meta.pageName || '',
      currentpage_url: to.fullPath,
      currentpage_id: to.params.id || '', // 当前内容ID
      env: Config.env
    };
    // 神策公共属性
    Vue.prototype.$sa.registerPage(obj);
    // 浏览轨迹
    Vue.prototype.$sa.re_pageview();
  });
};
